// Formatting and sorting helpers for revealed picks list

function toTitleCase(s) {
  if (!s || typeof s !== 'string') return '';
  return s
    .trim()
    .toLowerCase()
    .replace(/\b([a-z])/g, (m, c) => c.toUpperCase());
}

function emailLocalPart(email) {
  if (!email || typeof email !== 'string') return '';
  const i = email.indexOf('@');
  return (i > 0 ? email.slice(0, i) : email).trim();
}

// Returns "<LastName> <FirstInitial> - <EntryName>"
// Fallbacks:
// - If last or first missing, use what is present
// - If no name, use email local-part
// - Entry falls back to entry_id
export function formatUserEntryDisplay({ user_name, user_email, entry_name, entry_id }) {
  let first = '', last = '';
  if (user_name && typeof user_name === 'string') {
    const parts = user_name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
      // Could be either first or last; treat as last
      last = toTitleCase(parts[0]);
    } else if (parts.length > 1) {
      first = toTitleCase(parts[0]);
      last = toTitleCase(parts[parts.length - 1]);
    }
  }

  if (!first && !last) {
    const lp = emailLocalPart(user_email || '');
    last = lp ? toTitleCase(lp) : '';
  }

  const firstInitial = first ? `${first[0].toUpperCase()}` : '';
  const namePart = last && firstInitial ? `${last} ${firstInitial}` : (last || first || '');
  const entryPart = (entry_name && String(entry_name).trim()) || (entry_id != null ? String(entry_id) : '');
  return namePart && entryPart ? `${namePart} - ${entryPart}` : (namePart || entryPart || '');
}

export function displayKeyForPick(p) {
  return (formatUserEntryDisplay({
    user_name: p?.user_name,
    user_email: p?.user_email,
    entry_name: p?.entry_name,
    entry_id: p?.entry_id,
  }) || '').toLowerCase();
}

export function teamKeyForPick(p) {
  const t = (p?.team_name || p?.team_abbr || '').toString();
  return t.toLowerCase();
}

export function stableCompare(a, b) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

export function sortPicksByDisplay(picks) {
  const arr = (picks || []).slice();
  arr.sort((a, b) => stableCompare(displayKeyForPick(a), displayKeyForPick(b)) || stableCompare(String(a.id || a.entry_id || ''), String(b.id || b.entry_id || '')));
  return arr;
}

export function sortPicksByTeam(picks) {
  const arr = (picks || []).slice();
  arr.sort((a, b) => stableCompare(teamKeyForPick(a), teamKeyForPick(b)) || stableCompare(displayKeyForPick(a), displayKeyForPick(b)) || stableCompare(String(a.id || a.entry_id || ''), String(b.id || b.entry_id || '')));
  return arr;
}

const formatDisplay = {
  toTitleCase,
  formatUserEntryDisplay,
  displayKeyForPick,
  teamKeyForPick,
  sortPicksByDisplay,
  sortPicksByTeam,
  stableCompare,
};

export default formatDisplay;
